import React, { useState } from "react";
import { FaSearch } from "react-icons/fa";
import "./ConferencePapers.css";

const files = [
  { id: 1, 
    title: "Actuarial Capacity Development - ASG Convention 2017 - Joseph Poku", 
    cover: "/Conference-Papers/Page-Covers/Actuarial-Capacity.png", 
    pdf: "/Conference-Papers/Actuarial Capacity Development.pdf" 
  },
  { id: 2, 
    title: "Actuaries Value to Emerging Markets- ASG Convention 2017 - Schallk van Tonder ", 
    cover: "/Conference-Papers/Page-Covers/Actuaries Value.png", 
    pdf: "/Conference-Papers/Actuaries Value.pdf"
  },
  { id: 3, title: "CriticalConsideration for Reserving - ASG Convention 20170 - Ortopah Botchey",
    cover: "/Conference-Papers/Page-Covers/CriticalConsideration.png", 
    pdf: "/Conference-Papers/CriticalConsideration for Reserving - ASG Convention 20170 - Ortopah Botchey.pdf" 
  },
  { id: 4, 
    title: "Data Preparation for Valuation- ASG Convention 2017 - Kakra & Kofi", 
    cover: "/Conference-Papers/Page-Covers/Data Preparation for Valuation- ASG Convention 2017 - Kakra & Kofi.png", 
    pdf: "/Conference-Papers/Data Preparation for Valuation- ASG Convention 2017 - Kakra & Kofi.pdf"
  },
  { id: 5, title: "General Equilibrium Model for Banking - ASG_Convention 2017 - Kojo Essel-Mensah", 
    cover: "/Conference-Papers/Page-Covers/General Equilibrium Model for Banking - ASG_Convention 2017 - Kojo Essel-Mensah.png", 
    pdf: "/Conference-Papers/General Equilibrium Model for Banking - ASG_Convention 2017 - Kojo Essel-Mensah.pdf" 
  },
  { id: 6, 
    title: "Ghana Mortality Table - ASG Convention 2017 - Seth Eshun", 
    cover: "/Conference-Papers/Page-Covers/Ghana Mortality Table - ASG Convention 2017 - Seth Eshun.png", 
    pdf: "/Conference-Papers/Ghana Mortality Table - ASG Convention 2017 - Seth Eshun.pdf" 
  },
  { id: 7, 
    title: "IAA Presentation-ASG Convention 2017 - Renata De Leers", 
    cover: "/Conference-Papers/Page-Covers/IAA Presentation-ASG Convention 2017 - Renata De Leers.png", 
    pdf: "/Conference-Papers/IAA Presentation-ASG Convention 2017 - Renata De Leers.pdf" 
  },
  { id: 8, 
    title: "Implementing RBC in Ghana - Connect 24 - NIC", 
    cover: "/Conference-Papers/Page-Covers/Implementing RBC in Ghana - Connect 24 - NIC.png", 
    pdf: "/Conference-Papers/Implementing RBC in Ghana - Connect 24 - NIC.pdf" 
  },
  { id: 9, 
    title: "Professionalim_Case Studies - ASG Connect 2024 - Michael Tichereva", 
    cover: "/Conference-Papers/Page-Covers/Professionalim_Case Studies - ASG Connect 2024 - Michael Tichereva.png", 
    pdf: "/Conference-Papers/Professionalim_Case Studies - ASG Connect 2024 - Michael Tichereva.pdf" 
  },
  { id: 10, 
    title: "UNDP-Milliman GAIN Update - ASG Connect 2024 - Mark Henaku", 
    cover: "/Conference-Papers/Page-Covers/UNDP-Milliman GAIN Update - ASG Connect 2024 - Mark Henaku.png", 
    pdf: "/Conference-Papers/UNDP-Milliman GAIN Update - ASG Connect 2024 - Mark Henaku.pdf" 
  },
];

const ConferencePapers = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const filesPerPage = 8;

  // Filter files by search term
  const filteredFiles = files.filter((file) =>
    file.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Pagination logic
  const indexOfLastFile = currentPage * filesPerPage;
  const indexOfFirstFile = indexOfLastFile - filesPerPage;
  const currentFiles = filteredFiles.slice(indexOfFirstFile, indexOfLastFile);
  const totalPages = Math.ceil(filteredFiles.length / filesPerPage);

  return (
    <div className="Conference-Papers">
      <section className="section">
        <div className="sectiontop-line"></div>
        <h2 className="sectiontitle">CONFERENCE PAPERS</h2>
        <div className="sectionbottom-line"></div>
      </section>
    
      <div className="library-container">
        {/* Search Bar */}
        <div className="search-bar">
          <FaSearch className="search-icon" />
          <input
            type="text"
            placeholder="Search files by topic..."
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setCurrentPage(1); // Reset to first page on search
            }}
          />
        </div>

        {/* File Cards */}
        <div className="file-grid">
          {currentFiles.length > 0 ? (
            currentFiles.map((file) => (
              <div
                key={file.id}
                className="file-card"
                onClick={() => window.location.href = `/pdf-viewer/${encodeURIComponent(file.pdf)}`}
              >
                <img src={file.cover} alt={file.title} className="file-cover" />
                <p className="file-title">{file.title}</p>
              </div>
            ))
          ) : (
            <p className="no-results">No files found</p>
          )}
        </div>

        {/* Pagination Controls */}
        {filteredFiles.length > filesPerPage && (
          <div className="pagination">
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
            >
              « Prev
            </button>
            {Array.from({ length: totalPages }, (_, i) => (
              <button
                key={i + 1}
                className={currentPage === i + 1 ? "active" : ""}
                onClick={() => setCurrentPage(i + 1)}
              >
                {i + 1}
              </button>
            ))}
            <button
              onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
              disabled={currentPage === totalPages}
            >
              Next »
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ConferencePapers;
